var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12.3047,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3047,
    y: 8,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3047,
    y: 12.3047,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6172,
    y: 8,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6172,
    y: 12.3047,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9219,
    y: 8,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9219,
    y: 12.3047,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16.6172,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20.9219,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3047,
    y: 16.6172,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3047,
    y: 20.9219,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6172,
    y: 16.6172,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6172,
    y: 20.9219,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9219,
    y: 16.6172,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9219,
    y: 20.9219,
    width: 3.07692,
    height: 3.07692,
    rx: 0.6,
    fill: "#707070"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid3);
export default __webpack_public_path__ + "static/media/grid3.4a072c5c26900b42cc231f7d0755ce03.svg";
export { ForwardRef as ReactComponent };